/**
 * AR Vision Demo — demo-only route paths.
 *
 * THROWAWAY DEMO CODE. Centralizes the URL strings for the demo-only pages so
 * the page component, the Nami nav tool, and the `routes.tsx` registration all
 * agree. Kept here (not in production `paths.ts`) so the whole demo stays an
 * isolated, deletable unit.
 */

/** Scene 6 — "last 5 sent reminder emails" list view (T7). */
export const REMINDERS_DEMO_PATH = '/demo/ar/reminders';

/** Scenes 12-14 — bespoke bank-reconciliation view (AR Technical Demo F4). */
export const RECONCILIATION_DEMO_PATH = '/demo/ar/reconciliation';

// AR Technical Demo (F3 / GEN-2259) — Scenes 7-9 & 11: the mock Crestline vendor
// portal renders as a POPUP OVERLAY (`CrestlinePortalOverlay`, driven by
// `portal-store`), not a route — so there is no portal path here.

// AR Email Intelligence Demo (GEN-2263) — Scene 0 corpus-learning surface (E1).
/** Scene 0 — "what I learned from your inbox" corpus-learning visualization. */
export const INTEL_CORPUS_DEMO_PATH = '/demo/ar/intel/corpus';

/**
 * AR Email Intelligence Demo (E2 / GEN-2264) — voice / draft hero surface.
 * Hosts Scenes 1–3 (voice profile, the split-screen voice draft, tone
 * variants), switched by the `scene` search param. Delete with src/demo/ar.
 */
export const VOICE_INTEL_DEMO_PATH = '/demo/ar/voice';

/** The three scenes the voice surface can show, keyed by the `scene` param. */
export type VoiceIntelScene = 'profiles' | 'draft' | 'tone';

// AR Email Intelligence Demo (E3 / GEN-2265) — Scenes 4–5 surface. Delete with
// frontend/src/demo/ar/email-intel.
/** Scenes 4–5 — auto-built Customer Intelligence panel for Granite Peak. */
export const INTEL_INTELLIGENCE_DEMO_PATH = '/demo/ar/intelligence';

// AR Email Intelligence Demo (GEN-2266) — E4 payoff surface route. Delete with
// frontend/src/demo/ar/email-intel.
/** Email-Intel Scene 6 — Granite Peak send + warm-reply payoff surface (E4). */
export const INTEL_SEND_DEMO_PATH = '/demo/ar/intel/send';

/**
 * Blanket cash-receipt ingestion across all linked bank accounts (the
 * "process today's cash receipts" Today's-work task → `CashReceiptIngestionPage`).
 */
export const CASH_RECEIPT_INGESTION_DEMO_PATH = '/demo/ar/cash-receipts';
